import React from "react";
import { WaterTye } from "../types";

interface WaterTypeRadioProps {
  title: string;
  type: string,
  values: WaterTye[];
  labels: string[];
  available_values: WaterTye[];
  name: string;
  selectedValue: string;
  onChange: (value: WaterTye) => void;
}

function WaterTypeRadio({
  title,
  values,
  labels,
  name,
  selectedValue,
  available_values,
  onChange,
}: WaterTypeRadioProps) {
    
    // Filter to show only available values and their corresponding labels
    const filteredIndices = values.reduce<number[]>((indices, value, index) => {
        if (available_values.includes(value)) {
            indices.push(index);
        }
        return indices;
    }, []);
    
    return (
        <div className="p-4 border rounded-md">
        <p className="font-semibold mb-2">{title}</p>
        <div className="space-y-2">
            {filteredIndices.map(index => (
            <label key={values[index]} className="flex items-center gap-2 cursor-pointer">
                <input
                type="radio"
                name={name}
                value={values[index]}
                checked={selectedValue === values[index]}
                onChange={() => onChange(values[index])}
                className="cursor-pointer"
                />
                {labels[index]}
            </label>
            ))}
        </div>
        </div>
    );
}

export default WaterTypeRadio;